import { RESULT_FAIL } from "../actions/constants";
import { LOAD_QUESTIONNAIRE, UPDATE_QUESTIONNAIRE, RESET_QUESTIONNAIRE } from "../actions/types";

const initialState = {
  data: null,
  params: {},
  answers: {},
  activeIndex: 0,
  test_details: {},
  isLoading: true,
  isStarted: false,
  isCompleted: false,
  response_id: null,
  result: RESULT_FAIL,
  error: null,
};

const responseReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOAD_QUESTIONNAIRE:
      return { ...initialState, isLoading: false, ...payload };

    case UPDATE_QUESTIONNAIRE:
      return { ...state, isLoading: false, ...payload };

    case RESET_QUESTIONNAIRE:
      return initialState;

    default:
      return state;
  }
};

export default responseReducer;
